import api from './api'

const FacturaVentaItemService = {}

FacturaVentaItemService.consultar = async function(id){
    return api.get('/FacturaVenta/Items/'+id).then(res => res.data);
}


export default FacturaVentaItemService